import { makeStyles } from '@material-ui/core';

const styles = makeStyles(() => ({
  permisosContainer: {
    marginTop: 10,
  },
  label: {
    fontSize: 12,
    fontWeight: 'bold',
    marginTop: -5
  },
  tablaPermisosSitios: {
    marginTop: 10,
  },bloqueTabla:{
    backgroundColor: '#31346C'
  },
  columnaIzq:{
    marginLeft: '10',
    
    width: '100%'
  },
}));

export default styles;
